<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef"> </p>

    <!-- LAYER OF 2 BUTTERFLIES WITH DEDICATED CLASSES FOR CSS CONTROL -->
    <div class="mariposas-layer">
      <img 
        ref="mariposa1Ref"
        src="@/assets/mariposa.png" 
        alt="Butterfly 1" 
        class="mariposa-img mariposa-1"
      >
      <img 
        ref="mariposa2Ref"
        src="@/assets/mariposa.png" 
        alt="Butterfly 2" 
        class="mariposa-img mariposa-2"
      >
    </div>

    <!-- MASK 1: Centered top above Save the Date -->
    <div class="mascara-group mascara1-group" ref="disco1Ref">
      <img src="@/assets/coronaa.png" alt="Mask" class="mascara-img" />
    </div>

    <!-- Date container -->
    <div class="fecha-evento" ref="fechaRef"> <br>
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Saturday</p>
      <p class="fecha-dia-numero" ref="numeroRef">17</p>
      <p class="fecha-mes" ref="mesRef">OCTOBER</p>
      <p class="fecha-anio" ref="anioRef">2026</p><br><br>
    </div>

    <!-- Main content -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
         <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
          15 years ago my story began, a journey full of laughter, lessons, and shared dreams.
<br><br>

Today, that path brings me here, to this very special day where I celebrate not only my life, but also the love of those who have been with me every step of the way.
<br>
<br>

This invitation is a window to my heart, and I am so excited for you to be here to accompany me.
Welcome to an unforgettable chapter of this story that is just beginning.<br><br>

     </p>
        </div>
        <div class="versiculo-final" ref="versiculoFinalRef">
          <p class="texto-versiculo"></p>
          <p class="referencia-versiculo"></p>
        </div>
      </div>
    </div>

    <!-- MASK 2: On the left next to the text -->
    <div class="mascara-group mascara2-group" ref="disco2Ref">
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',

  setup() {
    const mensaje = ref('');

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);

    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);

    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    const mariposa1Ref = ref(null);
    const mariposa2Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.2 }
      );

      observer.observe(el);
    };

    onMounted(() => {
      const iniciarAnimacion = () => {
        const tl = gsap.timeline({
          defaults: { ease: 'power2.out', duration: 0.5 }
        });

        // 1. PRIMERAS EN ENTRAR: MÁSCARAS Y TÍTULO PRINCIPAL (EN PARALELO AL INICIO)
        tl.fromTo(granDiaRef.value, 
            { opacity: 0, y: 20 }, 
            { opacity: 1, y: 0 }
          )
          .fromTo(disco1Ref.value, 
            { opacity: 0, y: -30, scale: 0.8 }, 
            { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'back.out(1.2)' }, 
            0
          )
          .fromTo(disco2Ref.value, 
            { opacity: 0, x: -30, scale: 0.8 }, 
            { opacity: 1, x: 0, scale: 1, duration: 0.6, ease: 'back.out(1.2)' }, 
            0.1
          )
          .fromTo(rama1Ref.value, 
            { opacity: 0, scale: 0.8 }, 
            { opacity: 1, scale: 1, duration: 0.5 }, 
            '<'
          )
          .fromTo(rama2Ref.value, 
            { opacity: 0, scale: 0.8 }, 
            { opacity: 1, scale: 1, duration: 0.5 }, 
            '<'
          )

        // 2. ENTRADA FLUIDA Y CONSECUTIVA DEL RESTO DEL CONTENIDO
          .fromTo(diaSemanaRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.3')
          .fromTo(numeroRef.value, { opacity: 0, scale: 0.8, y: -20 }, { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: 'back.out(1.5)' }, '-=0.3')
          .fromTo(mesRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.3')
          .fromTo(anioRef.value, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.3')
          .fromTo(mensajeRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, '-=0.3')
          .fromTo(versiculoTextRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6 }, '-=0.3');

        // MOVIMIENTO FLOTANTE CONTINUO DE MÁSCARAS
        gsap.to([disco1Ref.value, disco2Ref.value], {
          y: '+=6',
          duration: 3,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        });
      };

      animateOnScroll(granDiaRef.value, iniciarAnimacion);

      // FLOTACIÓN LIGERA DE MARIPOSAS
      if (mariposa1Ref.value) {
        gsap.to(mariposa1Ref.value, {
          y: '+=8',
          x: '+=5',
          duration: 2.8,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        });
      }

      if (mariposa2Ref.value) {
        gsap.to(mariposa2Ref.value, {
          y: '+=8',
          x: '-=5',
          duration: 3.2,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        });
      }
    });

    return {
      mensaje,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,
      mensajeRef,
      versiculoTextRef,
      versiculoRef,
      disco1Ref,
      disco2Ref,
      rama1Ref,
      rama2Ref,
      mariposa1Ref,
      mariposa2Ref
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  background: transparent;
  color: black;
  width: 100%;
  min-height: 40vh;
  padding: 0 5vw;
  margin-bottom: 2vh;
  margin-top: 12vh;
  box-sizing: border-box;
  position: relative;
  overflow: visible;
}

/* ==========================================
    CAPA DE MARIPOSAS Y CONTROL CSS INDIVIDUAL
    ========================================== */
.mariposas-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 6;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 0.95;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  animation: aleteoBonito 1.5s infinite ease-in-out alternate;
  will-change: transform;
}

/* CONTROLES CSS PARA MOVER LA MARIPOSA 1 */
.mariposa-1 {
  top: 0%;
  right: 6vw;
  width: clamp(45px, 14vw, 68px);
  transform: rotate(-12deg);
}

/* CONTROLES CSS PARA MOVER LA MARIPOSA 2 */
.mariposa-2 {
  top: 32%;
  left: 8vw;
  width: clamp(38px, 11vw, 52px);
  transform: rotate(15deg);
}

@keyframes aleteoBonito {
  0% { 
    transform: scaleX(1); 
  }
  100% { 
    transform: scaleX(0.55); 
  }
}

/* ==========================================
    FECHA ESTILO METÁLICO NÍTIDO
    ========================================== */
.fecha-evento {
  text-align: center;
  margin: 4vh 0 3vh;
  position: relative;
  z-index: 5;
}
.fecha-gran-dia, .fecha-dia-semana, .fecha-dia-numero, .fecha-mes, .fecha-anio {
  background: #090551;
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.25));
  display: block;
  margin: 0 auto;
  letter-spacing: 1px;
}

.fecha-gran-dia { font-family: 'CynthiaJuneJF', cursive; font-size: clamp(2.8rem, 12vw, 3.8rem); }
.fecha-dia-semana { font-family: 'fecha', serif; font-size: clamp(1.2rem, 5vw, 1.6rem); margin: 1vh 0; }
.fecha-dia-numero { font-family: 'fecha', serif; font-size: clamp(3.2rem, 15vw, 4.2rem) !important; font-weight: bold; }
.fecha-mes { font-family: 'Playfair Display', serif; font-size: clamp(1.1rem, 4.5vw, 1.5rem); font-weight: 600; letter-spacing: 0.1em; }
.fecha-anio { font-family: 'Poppins', sans-serif; font-size: clamp(0.8rem, 3.2vw, 0.95rem); font-style: italic; }

/* Contenido de Texto */
.bienvenida-container { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  position: relative; 
  z-index: 5; 
  width: 100%;
}

.mensaje-bienvenida { 
  font: 300 clamp(0.9rem, 3.8vw, 1.1rem) 'Josefin Sans', sans-serif; 
  color: #000; 
  text-align: center; 
  line-height: 1.8; 
}

.versiculo-container {
  margin: -1vh auto 0;
  padding: 0 6vw;
  width: 100%;
  max-width: 580px;
  text-align: center;
  letter-spacing: 0.02em;
  box-sizing: border-box;
}

.versiculo-texto { 
  font: clamp(1.1rem, 3.8vw, 1.25rem) 'quote', sans-serif; 
  line-height: 1.8; 
  color: #333; 
}

.letra-quince {
  font-family: 'CynthiaJuneJF', cursive; 
  font-size: clamp(2.8rem, 12vw, 3.8rem);
  background: #090551;
  padding-right: 2vw;
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
}

/* ==========================================
    GRUPOS DE MÁSCARAS
    ========================================== */
.mascara-group {
  position: absolute;
  pointer-events: none;
  z-index: 3;
}

.mascara-img {
  width: clamp(150px, 40vw, 350px) !important;
  height: auto;
  margin-top:-40px;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.12));
}

.rama-decorativa {
  position: absolute;
  width: clamp(150px, 50vw, 280px);
  height: auto;
  z-index: 1;
  opacity: 0.9;
}

.mascara1-group {
  top: -45px !important;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}

.rama1 {
  right: -10px;
  transform: rotate(15deg);
}

.mascara2-group {
  top: 28%;
  right: -5vw;
}

.rama2 {
  top: -40px;
  left: -20px;
  transform: rotate(-10deg) scaleX(-1);
}
</style>